/* eslint-disable */
import { useDrupalSettings } from "./composables/useDrupalSettings";
const { config } = useDrupalSettings();

__webpack_public_path__ = `${config.entryUrl}`;
